export const app = {
  loading: 'Bezig met laden...'
}
